export const NavbarLinks = [
  {
    title: "Who",
    subLinks: [
      { name: "Exporters/SMEs & Consultants", link: `/who/${"exporters"}` },
//      { name: "Consultancies", link: `/who/${"consultancies"}` },
      { name: "Investment/Fund Managers", link: `/who/${"investment-managers"}`, },
      { name: "Energy/Emissions Analysts", link: `/who/${"energy-analysts"}` },
      { name: "Higher Education Institutions", link: `/who/${"higher-education-institutions"}`, },
    ],
  },

  {
    title: "Why",
    subLinks: [
      { name: "Global Risk", link: `/why/${"global-risk"}` },
      { name: "Scenario Analysis", link: `/why/${"scenario-analysis"}` },
      { name: "Transition Risks", link: `/why/${"transition-risks"}` },
    ],
  },
  {
    title: "What",
    subLinks: [
      { name: "Pre-run Scenarios", link: `/what/${"prerun-scenarios"}` },
      {
        name: "Bespoke - Scenarios & Models",
        link: `/what/${"bespoke-scenariosModels"}`,
      },
      { name: "risk2NZ App", link: `/what/${"risk2NZ-app"}` },
      //      { name: "Bespoke Models", link: `/what/${"bespoke-models"}` },
    ],
  },
  {
    title: "How",
    subLinks: [
      { name: "mGEM-Global Macro", link: `/how/${"mGEM-global-macro"}` },
      { name: "finGEM-Global Finance", link: `/how/${"finGEM-global-finance"}`, },
      { name: "eGEM-Global Emissions", link: `/how/${"eGEM-global-emissions"}`, },
      { name: "enGEM-Global Energy", link: `/how/${"enGEM-global-energy"}` },
      { name: "defGEM-Global Defence", link: `/how/${"defGEM-global-defence"}` },
      { name: "stuGEM-Global Students", link: `/how/${"stuGEM-global-students"}` },
    ],
  },
  {
    title: "Team",
    subLinks: [
      { name: "Model Team", link: `/team/${"model-team"}` },
      { name: "SME Team", link: `/team/${"SME-team"}` },
      { name: "Education Team", link: `/team/${"education-team"}` },
      { name: "Finance/Portfolio Team", link: `/team/${"portfolio-team"}` },
      { name: "MEF Associates", link: `/team/${"mef-associates"}` },
      { name: "Software Engineers", link: `/team/${"software-engineers"}` },
    ],
  },
  // {
  //   title: "News",
  //   subLinks: [
  //     { name: "Data Releases", link: `/news/${"data-releases"}` },
  //     { name: "Policy Updates", link: `/news/${"policy-update"}` },
  //     { name: "Model Research", link: `/news/${"model-research"}` },
  //     { name: "Technology", link: `/news/${"technology"}` },
  //   ],
  // },
  {
    title: "Subscribe",
    subLinks: [ 
      { name: "Exporters/SMEs", link: `/subscribe/${"exporters-sme"}`, }, 
      { name: "Consultancies", link: `/subscribe/${"consultancies"}`, }, 
      { name: "Investment/Fund Managers", link: `/subscribe/${"investment-managers"}`, }, 
      { name: "Energy/Emissions Analysts", link: `/subscribe/${"energy-analysts"}`, }, 
      { name: "Higher Education Institutions", link: `/subscribe/${"hg-institutions"}`, },
      ],
  },
  //  {
  //    title: "Subscribe",
  //    subLinks: [
  //      { name: "Bespoke Scenarios/Models", link: `/subscribe/${"bespoke-subscribe"}` },
  //      { name: "Portfolio/Esg Models", link: `/subscribe/${"portfolio-subscribe"}` },
  //      { name: "risk2NZ App License", link: `/subscribe/${"risk2NZ-subscribe"}` },
  //      { name: "Education Courses/Apps", link: `/subscribe/${"education-subscribe"}` },
  //    ],
  //  },
  {
    title: "Case Studies",
        subLinks: [
          // ----- SME/Exporters Group
          { name: "MissanOil", link: "why/case-study/MissanOil", group: "SME/Exporters" }, 
          { name: "BaowuSteel", link: "why/case-study/BaowuSteel", group: "SME/Exporters" }, 
          // ----- Consultancies Group
          { name: "DAS", link: "why/case-study/DAS", group: "Consultancies" }, 
//          { name: "iDEA", link: "why/case-study/iDEA", group: "Consultancies" }, 
          { name: "Senaryo", link: "why/case-study/Senaryo", group: "Consultancies" },
          // ----- Universities Group
          { name: "AMBS", link: "why/case-study/AMBSexecEd", group: "Universities" }, 
          // ----- Finance Group
          { name: "SAI", link: "why/case-study/SAI", group: "Finance" }, 
          // ----- Energy/GHG Group 
    //    {	name: "Octopus",	link: "why/case-study/Octopus", group: "Energy/GHG" 	},
          { name: "Iraqi Oil Ministry", link: "why/case-study/MissanOil", group: "Energy/GHG" }     ],
      },
// --------------------------------------------------- General Risk Mitigation (Neglect) Stories
  {
    title: "Risk Stories",
    subLinks: [
      { name: "Offshore Wind", link: `/RiskStories/${"offshore-wind"}` },
      { name: "UK Universities", link: `/RiskStories/${"uk-universities"}` }, 
      { name: "Energy Prices", link: `/RiskStories/${"energy-hikes"}` }, 
    ],
  },

  // {
  //   title: "Downloads",
  //   subLinks: [
  //     { name: "risk2NZ Lite Signup", link: `/signup/${"riskNZlite"}` },
  //     { name: "MEF Publications", link: `/signup/${"scenario-analysis"}` },
  //     { name: "Other", link: `/signup/${"transition-risks"}` },
  //   ],
  //      subLinks: [
  //        { name: "risk2NZ Lite", link: `/signup/${"riskNZliteSignUp"}` },
  //        { name: "Reports", link: `/signup/${"reports-signup"}` },
  //        { name: "WhitePapers", link: `/signup/${"whitepapers-signup"}` },
  //      ],
  // },
  //  {
  //    title: "[Linked In/Twitter]", // style={{ color: "red",  }} ,
  //    subLinks: [
  //      { name: "Linked In ", link: "/" },
  //      { name: "TWitter", link: "/" },
  //      { name: "TikTok", link: "/" },
  //      { name: "WeChat", link: "/" },
  //    ],
  //  },
];

export const NavbarTitles = [
  {
    title: "Why",
    link: `/why/${"global-risk"}`,
  },
];
